import axios from 'axios'

const api = {

  async getPharmacy () {
    return await axios.get('/api/ap/pharmacies/current').then(response => response.data)
  },

  async getPharmacyPreview () {
    return await axios.get('/api/ap/pharmacies/preview').then(response => response.data)
  },

  async updatePharmacy (pharmacy) {
    return await axios.put('/api/ap/pharmacies', pharmacy)
    .then(response => response.data)
    .catch(error => error.response.data)
  },

  // user

  async getUser () {
    return await axios.get('/api/ap/users').then(response => response.data)
  },

  async updateUser (user) {
    return await axios.put('/api/ap/users', user)
    .then(response => response.data)
    .catch(error => error.response.data)
  },

  // election period

  async getElectionPeriod() {
   return await axios.get('/api/ap/electionperiods/active').then(response => response.data)
  },

  //practice periods

  async getPracticePeriods() {
    return await axios.get('/api/ap/practiceperiods').then(response => response.data)
   },

  // election period pharmacy

  async getElectionPeriodPharmacy () {
    return await axios.get('/api/ap/electionPeriodPharmacies').then(response => response.data)
  },

  async createElectionPeriodPharmacy(isAvailable) {
    return await axios.post('/api/ap/electionPeriodPharmacies', { isAvailable }).then(response => response.data)
  },

  async updateElectionPeriodPharmacy(isAvailable) {
    return await axios.put('/api/ap/electionPeriodPharmacies', { isAvailable }).then(response => response.data)
  },

  // practice slots

  async getPracticeSlots() {
    return await axios.get('/api/ap/practiceslots').then(response => response.data)
  },

  // async getCurrentElectionPeriodUniversities () {
  //   return await axios.get('/ap/electionPeriodUniversities').then(response => response.data)
  // },

  async createPracticeSlots (practiceSlots) {
    return await axios.post('/api/ap/practiceslots', practiceSlots)
    .then(response => response.data)
    .catch(error => error.response.data)
  },

  async getImages () {
    return await axios.get('/api/ap/images').then(response => response.data)
  },

  async deleteImage (imageId) {
    return await axios.delete('/api/ap/images/' + imageId).then(response => response.data)
  },

  async uploadImage(image) {

    const formData = new FormData();
    formData.append('Image', image);

    // const config  = {
    //   headers: {
    //     'Content-Type': 'multipart/form-data'
    //   }
    // }

    await axios.post('/api/ap/images', formData) //, config)
  },

  async updateImagesOrder(imageIds) {
    return axios.post('/api/ap/images/order', imageIds).then(response => response.data)
  },

  // --

  async getResults () {
    return await axios.get('/api/ap/results').then (response => response.data)
  }

}

export default api